import Icon from './Icon';

const Compete = (props) => (
  <Icon
    {...props}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1231_245075)">
      <circle opacity="0.3" cx="28.0004" cy="28.0004" r="19.6" fill="#44CCFF" />
      <ellipse
        cx="26.0324"
        cy="28.1929"
        rx="24.5"
        ry="10.5"
        transform="rotate(-150 26.0324 28.1929)"
        stroke="#46BBE7"
        strokeWidth="2.8"
        fill="none"
      />
      <circle cx="45.5" cy="10.5" r="3.5" fill="#46BBE7" />
      <circle cx="6.31738" cy="44.1846" r="3.5" fill="#46BBE7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.5409 15.3339C48.8231 15.9346 47.9696 16.3783 47.033 16.6124C47.2997 17.3808 47.3191 18.3381 47.0142 19.5067C46.6289 20.9833 45.7467 22.6963 44.3695 24.5371C41.6184 28.2144 37.0602 32.1775 31.3251 35.4888C25.5899 38.8 19.8786 40.7659 15.3184 41.3097C14.113 41.4535 13.0075 41.4956 12.0158 41.4437C12.3909 42.2502 12.6003 43.1494 12.6003 44.0975C12.6003 44.1529 12.5996 44.2083 12.5982 44.2634C13.5718 44.276 14.5938 44.216 15.65 44.09C20.6693 43.4914 26.7421 41.3679 32.7251 37.9136C38.708 34.4594 43.5834 30.2619 46.6115 26.2144C48.1239 24.1929 49.2176 22.1525 49.7235 20.2135C50.1642 18.5244 50.1738 16.8384 49.5409 15.3339ZM40.1083 13.7605C39.5139 13.7798 38.8875 13.8279 38.2317 13.9061C33.6715 14.45 27.9602 16.4159 22.2251 19.7271C16.4899 23.0383 11.9317 27.0015 9.18063 30.6787C7.80346 32.5195 6.9212 34.2325 6.53594 35.7092C6.32969 36.4997 6.27183 37.1935 6.33852 37.7976L6.3003 37.7975C5.33195 37.7975 4.41463 38.0159 3.59494 38.4063C3.42547 37.3111 3.52525 36.1574 3.82663 35.0023C4.33251 33.0634 5.42622 31.023 6.93862 29.0014C9.96667 24.9539 14.8421 20.7565 20.8251 17.3022C26.808 13.8479 32.8808 11.7244 37.9001 11.1258C38.3465 11.0726 38.7868 11.0311 39.2199 11.002C39.299 12.0061 39.6136 12.944 40.1083 13.7605Z"
        fill="#46BBE7"
      />
    </g>
    <defs>
      <clipPath id="clip0_1231_245075">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default Compete;
